/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import SDGIconComponent from '@g17eco/molecules/sdg-icon/sdg-icon';
import { getSDGShortTitle } from '../../../../../../constants/sdg-data';
import { ScorecardGoal } from '../../../../../../types/scorecard';
import './styles.scss';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

interface TopSDGProps {
  goals: Pick<ScorecardGoal, 'actual' | 'sdgCode'>[];
  disabled?: boolean;
  width?: number;
  height?: number;
  handleSDGClick?: (sdgCode: string) => void;
}

const TopSdgs = (props: TopSDGProps) => {
  const { goals, disabled = false, width = 40, height = 40, handleSDGClick = () => { } } = props;

  const topSDGs = [...goals].sort((a, b) => {
    const av = a.actual || 0;
    const bv = b.actual || 0;
    return av < bv ? 1 : av > bv ? -1 : 0
  }).slice(0, 3);


  return <div className='top-sdgs-component mt-2'>
    {topSDGs.map((d, i) => {
      if (d.actual === undefined || d.actual === 0) {
        return <span key={i}><div className='sdg-icon-placeholder' style={{ width: `${width}px`, height: `${height}px` }} /></span>;
      }

      return <SimpleTooltip key={i} text={`SDG ${d.sdgCode}: ${getSDGShortTitle(d.sdgCode)}`}>
        <span style={{ cursor: disabled ? 'default' : 'pointer' }} onClick={disabled ? undefined : () => handleSDGClick(d.sdgCode)}>
          <SDGIconComponent width={width} height={height} code={d.sdgCode} />
        </span>
      </SimpleTooltip>
    })}
  </div>
}

export default TopSdgs;
